module.exports = __webpack_public_path__ + "static/img/cash-coins-money.5424fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/cash-coins-money.jpg
// module id = 8Yxs
// module chunks = 0